"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var AboutModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AboutModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const merge_1 = __importDefault(require("lodash/merge"));
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let AboutModuleForm = AboutModuleForm_1 = class AboutModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
        this.newStat = { label: '', unit: '', value: '' };
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = AboutModuleForm_1.getInitialContent();
    }
    /**
     * Paragraph parsed from tag <br>
     */
    get aboutTextContent() {
        if (this._content.text) {
            return this._content.text.replace(/<br\s*[/]?>/gi, '\n');
        }
        return '';
    }
    /**
     * Paragraph parsed with tag <br>
     */
    set aboutTextContent(value) {
        this._content.text = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
    /**
     * Function to check if header exist
     */
    get hasHeader() {
        return this._content.header !== null;
    }
    /**
     * Function to set header according to hasHeader value
     */
    set hasHeader(value) {
        if (!value) {
            this._content.header = null;
            return;
        }
        this._content.header = {
            small: null,
            intro: {
                isBold: false,
                text: null
            },
            large: null
        };
    }
    /**
     * Vue lifecycle hook.
     */
    mounted() {
        this.$nextTick(() => {
            this.findImagesRelated(this._content.image);
        });
    }
    /**
     * Function to add new stat item to content
     */
    addNewItem() {
        this._content.stats = [...this._content.stats, { ...JSON.parse(JSON.stringify(this.newStat)) }];
    }
    /**
     * Function to delete stat
     *
     * @param index of item to delete
     */
    deleteStatItem(index) {
        const statsCopy = [...this._content.stats];
        statsCopy.splice(index, 1);
        this._content.stats = statsCopy;
    }
    /**
     * Function to find image source
     */
    findImageSource() {
        this.pickRelated(services_1.Picker.Media, this.setImageSource);
    }
    /**
     * Function to check if background image is selected.
     */
    hasImage() {
        return !!this._content.image && typeof this._content.image.value !== 'undefined';
    }
    /**
     * Function to remove background image
     */
    removeImage() {
        this._content.image = null;
    }
    /**
     * Function to find image related
     */
    findImagesRelated(related) {
        if (!related || typeof related.value === 'undefined' || typeof related.type === 'undefined') {
            return;
        }
        this.describe(related, 'url');
    }
    /**
     * Function to set background image source
     */
    setImageSource(source) {
        this._content.image = source;
        this.$nextTick(() => {
            this.findImagesRelated(source);
        });
    }
    /**
     * @inheritDoc
     * @override
     */
    setInitialContent() {
        this._content = merge_1.default(this.initialContent, this._content);
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.About,
            size: {
                colSpan: 6,
                isResizable: false,
                maxColSpan: 6,
                maxRowSpan: 1,
                minColSpan: 6,
                minRowSpan: 1,
                rowSpan: 1
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            background: null,
            header: null,
            stats: [],
            image: null,
            text: null
        };
    }
};
AboutModuleForm = AboutModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'AboutModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixFile: backoffice_1.DashmixFile,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixTextArea: backoffice_1.DashmixTextArea,
            FormErrors: form_2.FormErrors,
            ModuleHeaderForm: form_2.ModuleHeaderForm
        },
        template: `
    <div>
      <!-- Header -->
      <DashmixCheck class="pb-2" :label="$t('forms.shared.hasHeader')" name="hasHeader"
                    :model.sync="hasHeader" />

      <ModuleHeaderForm v-if="hasHeader" :data.sync="_content.header" />
      <!-- Header| END -->

      <div class="row m-0">
        <div class="col-12 col-md-9 pl-md-0">
          <!-- Background -->
          <div class="form-group">
            <label for="background" class="d-block">{{ $t('forms.shared.background.label') }}</label>
            <DashmixInput type="color" :model.sync="_content.background" name="background"
                          :placeholder="$t('forms.shared.background.placeholder')" />
          </div>
          <!-- Background | END -->

          <!-- Text -->
          <div class="form-group">
            <label for="text" class="d-block">{{ $t('forms.about.text.label') }}</label>
            <DashmixTextArea :model.sync="aboutTextContent" name="text"
                             :placeholder="$t('forms.about.text.placeholder')" />
          </div>
          <!-- Text | END -->
        </div>

        <div class="col-12 col-md-3 pr-md-0">
          <!-- Image -->
          <label for="background" class="d-block">{{ $t('forms.about.image.label') }}</label>
          <DashmixButton variant="alt" :class="{'mb-4': !hasImage() }"
                         class="btn-block"
                         v-if="!disabled"
                         :icon="icons.SearchSolid"
                         :label="$t('forms.shared.search')"
                         @click="findImageSource" />

          <figure v-if="hasImage()" class="figure-with-btn__image-container mt-4">
            <DashmixFile class="figure-with-btn__image"
                         :file="{ thumbnail: _content.image ? description(_content.image) : '', type: 'jpg' }" />

            <DashmixButton class="figure-with-btn__delete-btn"
                           size="small" variant="icon" :icon="icons.TrashSolid" theme="danger"
                           @click="removeImage" />
          </figure>
          <!-- Image || END -->
        </div>
      </div>

      <div class="form-group mb-4">
        <label class="d-block">{{ $t('forms.about.elements') }}</label>
        <!-- Stats | END -->
        <template v-for="(stat, index) in _content.stats">
          <div class="bg-light py-3 row mx-0 my-3">
            <div class="col-11 p-0">
              <div class="row mx-0">
                <div class="col-12 pb-3">
                  <label :for="'label-' + index" class="d-block">{{ $t('forms.about.stats.label') }}</label>
                  <DashmixInput size="small" :model.sync="stat.label" :name="'stats-' + index"
                                :placeholder="$t('forms.about.stats.placeholder')" />
                </div>
              </div>
              <div class="row mx-0">
                <div class="col-12 col-md-6 pb-3">
                  <label :for="'unit-' + index" class="d-block">{{ $t('forms.about.unit.label') }}</label>
                  <DashmixInput size="small" :model.sync="stat.unit" :name="'unit-' + index"
                                :placeholder="$t('forms.about.stats.placeholder')" />
                </div>

                <div class="col-12 col-md-6 pb-3">
                  <label :for="'value-' + index" class="d-block">{{ $t('forms.about.value.label') }}</label>
                  <DashmixInput size="small" :model.sync="stat.value" :name="'value-' + index"
                                :placeholder="$t('forms.about.value.placeholder')" />
                </div>
              </div>
            </div>

            <div class="col-1 d-flex align-items-center p-0">
              <DashmixButton variant="icon" :icon="icons.TrashSolid" theme="danger"
                             @click="() => deleteStatItem(index)" />
            </div>
          </div>
        </template>

        <DashmixButton :icon="icons.PlusSolid" variant="icon"
                       :label="$t('forms.about.addNew')" @click="addNewItem" />
      </div>
      <!-- Stats | END -->

      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], AboutModuleForm);
exports.AboutModuleForm = AboutModuleForm;
//# sourceMappingURL=About.form.js.map